import { Copy, MessageCircle } from "lucide-react";
import { useNotify, useTranslate } from "ra-core";

import { Button } from "@/components/ui/button";

// One-time access link for a team member, shared by WhatsApp: the project has
// no outgoing mail server for people outside the Supabase account.
export const AccessLinkPanel = ({
  name,
  link,
  onDone,
}: {
  name: string;
  link: string;
  onDone: () => void;
}) => {
  const translate = useTranslate();
  const notify = useNotify();
  const message = translate("resources.sales.create.whatsapp_message", {
    name,
    link,
  });

  return (
    <div className="flex flex-col gap-3">
      <p className="font-semibold text-primary">
        {translate("resources.sales.create.link_ready", { name })}
      </p>
      <p className="text-sm text-muted-foreground">
        {translate("resources.sales.create.link_hint")}
      </p>
      <Button
        variant="outline"
        className="rounded-full"
        onClick={async () => {
          await navigator.clipboard.writeText(link);
          notify("crm.portal.invite.copied", { type: "success" });
        }}
      >
        <Copy className="size-4" />
        {translate("resources.sales.create.copy")}
      </Button>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center gap-2 rounded-full bg-[#25d366] px-4 py-2 text-sm font-semibold text-[#06301a] no-underline hover:opacity-90"
      >
        <MessageCircle className="size-4" />
        {translate("resources.sales.create.send_whatsapp")}
      </a>
      <Button className="rounded-full" onClick={onDone}>
        {translate("resources.sales.create.done")}
      </Button>
    </div>
  );
};
